type ErrorWithStatus = {
  response?: { statusCode?: number };
  cause?: ErrorWithStatus;
};

const isExpiredAuthTokenError = (error: unknown): boolean => {
  const { response, cause } = (error ?? {}) as ErrorWithStatus;
  return response?.statusCode === 401 || cause?.response?.statusCode === 401;
};

const toRejectableError = (error: unknown): Error => {
  if (error instanceof Error) return error;
  if (typeof error === "string") return new Error(error);
  if (
    error !== null &&
    typeof error === "object" &&
    "message" in error &&
    typeof (error as { message: unknown }).message === "string"
  ) {
    const err = new Error((error as { message: string }).message);
    err.cause = error;
    return err;
  }
  try {
    return new Error(JSON.stringify(error));
  } catch {
    return new Error("Unknown error");
  }
};

export { isExpiredAuthTokenError, toRejectableError };
